import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PagedZohoBookBillDetail } from 'src/app/admin/models/paged.zoho.book.bill.detail';
import { ZohoBookService } from 'src/app/admin/services/zoho.book.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';

@Component({
    selector: 'app-zoho-book-detail',
    templateUrl: './zoho.book.detail.component.html'
})
export class ZohoBookDetailComponent implements OnInit {

    totalRecords = 0;
    pagedZohoBookDetails = new PagedZohoBookBillDetail();
    subscriptions = new Array<Subscription>();
    tableModel = new TableModel();
    isModelLoaded = false;

    id: number;
    billNumber: string;

    totalAmount: number;

    get urls() {
        return PageUrls;
    }

    constructor(private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private zohoBookService: ZohoBookService,
        private route: ActivatedRoute) {
        this.tableModel.orderBy = 'Name';
        this.tableModel.orderByDirection = 'asc';
    }

    ngOnInit() {
        this.id = this.route.snapshot.queryParams.id;
        this.billNumber = this.route.snapshot.queryParams.billNumber;
        this.totalAmount = this.route.snapshot.queryParams.totalAmount;
        this.initSubscribers();
        this.getZohoBookBills();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getZohoBookBills());
        this.subscriptions.push(subscription);
    }

    getZohoBookBills() {
        this.spinner.show();
        this.zohoBookService.details(this.tableModel, this.id).subscribe(
            data => {
                Object.assign(this.pagedZohoBookDetails, data);
                this.totalRecords = data.totalCount;
                this.pagedZohoBookDetails.items.forEach(bill => {
                    const prefix = bill.size === 3 ? 'LG-' : bill.size === 2 ? 'MD-' : 'SM-';
                    bill.description = `${prefix}${bill.localId}-${bill.name}`;
                });

                this.spinner.hide();
                this.isModelLoaded = true;
            },
            error => {
                this.spinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
